(function ($) {
    if ($('.team').length) {
        $('.worker-swiper').each(function(index, element) {

            var teamSwiperElement = element;
            var teamSwiperPaginationElement = $(this).find('.swiper-pagination')[0];
            var teamSwiperNextElement = $(this).find('.swiper-button-next')[0];
            var teamSwiperPrevElement = $(this).find('.swiper-button-prev')[0];

            const workerSwiper = new Swiper(teamSwiperElement, {
                spaceBetween: 100,
                autoHeight: true,
                // hashNavigation: {
                //     watchState: false
                // },
                keyboard: {
                    enabled: true,
                    onlyInViewport:true,
                },
                loop: false,
                pagination: {
                    el: teamSwiperPaginationElement,
                    type: 'fraction',
                },
                navigation: {
                    nextEl: teamSwiperNextElement,
                    prevEl: teamSwiperPrevElement,
                },
                observer: true,
                observeParents: true,
                simulateTouch: false,
            });

            workerSwiper.on('slideChange', function () {
                window.location.hash = `worker-${$(this.slides[this.activeIndex]).data('worker')}`
            });

            /*
            $(window).on('hashchange', function() {
                if (!window.location.hash) {
                    $('.worker-modal').removeClass('active');
                    $('body').removeClass('overflow-hidden');
                } else {
                    const targetWorker = window.location.hash.split('worker-')[1];
                    if (targetWorker) {
                        workerSwiper.slideTo($(workerSwiper.slides).filter(`[data-worker=${targetWorker}]`).index(), 0);
                        window.location.hash = `worker-${targetWorker}`;
                        $('.worker-modal').addClass('active');
                        $('body').addClass('overflow-hidden');
                    }
                }
            });
            */

            $('body').on('click', '.open-worker-modal', function() {
                var targetModalID = $(this).data('modal-uniq-id');
                const targetWorker = $(this).data('worker');

                $(targetModalID).addClass('active');
                $('body').addClass('overflow-hidden');

                var correctSlideIndex = $(targetModalID).find('.worker-swiper .swiper-slide').filter(`[data-worker=${targetWorker}]`).index();

                if ( correctSlideIndex ) {
                    workerSwiper.slideTo(correctSlideIndex, 0);
                    window.location.hash = `worker-${targetWorker}`;
                }

            });



        });

        if ( window.location.hash.includes("worker") ) {
            const targetWorker = window.location.hash.split("worker-")[1];
            $('.open-worker-modal').filter(`[data-worker=${targetWorker}]`).trigger('click');
        }

        $('.worker-modal .close-button').on('click', function() {
            $('.worker-modal').removeClass('active');
            $('body').removeClass('overflow-hidden');
            window.history.pushState('', '/', window.location.pathname);
        });

        $(document).on('keyup',function(evt) {
            if (evt.keyCode === 27) {
                $('.worker-modal').removeClass('active');
                $('body').removeClass('overflow-hidden');
                window.history.pushState('', '/', window.location.pathname);
            }
        });

        $('.load-more-workers').on('click', function () {
            const button = $(this);
            const nextPage = button.data('next-page');
            const totalWorkers = button.data('total-workers');
            const workersPerPage = button.data('workers-per-page');
            const linkType = button.data('link-type');
            const linkText = button.data('link-text');
            const modalLinkText = button.data('modal-link-text');
            const hide = button.data('hide');
            button.addClass('loading');

            const data = {
                'action': 'load_more_workers',
                'next_page': nextPage,
                'total_workers': totalWorkers,
                'workers_per_page': workersPerPage,
                'link_type': linkType,
                'link_text': linkText,
                'modal_link_text': modalLinkText,
                'hide': hide,
            };

            $.get(liven.ajax_url, data, function (response) {
                button.removeClass('loading');
                if (response.success) {
                    $('.team-grid').append(response.data.workers)
                    button.data('next-page', response.data.nextPage);

                    if (response.data.lastPage) {
                        button.remove();
                    }
                }
            });
        });
    }
})(jQuery);
